import React from 'react';
import ReactDOM from 'react-dom/client';
import BearingTolerances from './BearingTolerances';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-bearing-tolerances',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<BearingTolerances />
		</React.StrictMode>
	);
}
